import { useTranslation } from 'react-i18next'

import { useUser } from '@/hooks/useUser'
import { TEXT_ELEMENT, TextComponent } from '@/types/components'

export type TextProps = Omit<TextComponent, 'componentType'>

export const Text = ({ id, element, textKey, justify }: TextProps) => {
  const { t } = useTranslation()
  const { user } = useUser()

  switch (element) {
    case TEXT_ELEMENT.TITLE:
      // We use h2 because it can be more than one title element on a step
      return (
        <h2 id={id} className={`font-bold ${justify ? `text-${justify}` : ''}`}>
          {t(textKey, {
            ...user?.data
          })}
        </h2>
      )

    case TEXT_ELEMENT.BODY:
      return (
        <p
          id={id}
          className={justify ? `text-${justify}` : ''}
          dangerouslySetInnerHTML={{
            __html:
              t(textKey, {
                ...user?.data
              }) ?? ''
          }}
        />
      )

    default:
      console.error(`Text element type ${element} not supported`)
      return null
  }
}
